import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import t from "@zendesk/client-i18n-tools";
import { Dots } from "@zendeskgarden/react-loaders";

import { Tag, Close } from "@zendeskgarden/react-tags";

import styles from "./styles.css";

export default class Filter extends PureComponent {
  static propTypes = {
    loading: PropTypes.bool,
    onClick: PropTypes.func,
    type: PropTypes.string.isRequired,
    value: PropTypes.string,
  };

  render() {
    const { loading, onClick, type, value } = this.props;

    return (
      <Tag size="large" data-test-id="filter">
        <strong className={styles.label}>
          {t(`knowledge-verification.filters.${type}`)}:
        </strong>
        &nbsp;
        <span className={styles.value}>
          {loading ? <Dots delayMS={0} className={styles.loader} /> : value}
        </span>
        {onClick && <Close onClick={onClick} />}
      </Tag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filter/FilterTag/index.js